import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// Define the structure for departments, including 'id' for content mapping
// and 'name' for display in the sidebar.
const departments = [
    { "name": "परिचय", "id": "about" },
    { "name": "संचालित पाठ्यक्रम", "id": "courses" },
    { "name": "संकाय सदस्य", "id": "faculty" },
    { "name": "समय सारिणी", "id": "timetable" },
    { "name": "सुविधाएं", "id": "facilities" },
    { "name": "सेमीनार/सम्मेलन/कार्यशाला", "id": "events" },
    { "name": "शोधच्छात्र", "id": "researchScholars" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

// Content for each section, mapped by their 'id'
const departmentContent = {
    "about": (
        <div>
            <p className="mb-2">महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के दर्शन विभाग की संकल्पना भारतीय दर्शन में गहन समझ और विशेषज्ञता को प्रज्वलित करने की दूरदर्शी खोज से हुआ है, जैसा कि प्राचीन ऋषियों द्वारा प्रतिपादित और पवित्र शास्त्रों में निहित है। महर्षि वाल्मीकि संस्कृत विश्वविद्यालय का दर्शन विभाग भारत के समृद्ध दार्शनिक विरासत के गहन और विशिष्ट ज्ञान को प्रस्तुत करता है, जो प्रमुख विचारधाराओं के भीतर विभिन्न अनुशासनों में गहरी समझ को विकसित करता है। यह अनोखा दृष्टिकोण विद्वानों को भारतीय दर्शन की जटिलताओं में महारत हासिल करने और इसके निरंतर विकास में अर्थपूर्ण योगदान करने में सक्षम बनाता है।</p>
            <p className="mb-2">दर्शन विभाग सभी दर्शनों के शिक्षण पर केंद्रित है। यह सभी दार्शनिक प्रणालियों के तुलनात्मक अध्ययन को विकसित करता है। सभी दार्शनिक प्रणालियों का तुलनात्मक अध्ययन करता है। भारत की समृद्ध दार्शनिक विरासत की व्यापक समझ प्रदान को विकसित करता है एवं विशिष्ट दृष्टि, बौद्धिक विकास और आध्यात्मिक अन्वेषण को बढ़ावा देते हैं।</p>
        </div>
    ),
    "courses": (
        <div>
            <p>दर्शन विभाग द्वारा शास्त्री व आचार्य के पाठ्यक्रम संचालित किए जाते हैं।</p>
        </div>
    ),
    "faculty": (
        <div className="mb-4">

            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>फोटो</th>
                            <th>आचार्य का नाम</th>
                            <th>पद</th>
                            <th>उच्चतम योग्यता</th>
                            <th>सम्पर्क</th>
                            <th>ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. विनय गोपाल त्रिपाठी (दर्शन विभाग).JPG")}
                                    alt="डॉ. विनय गोपाल त्रिपाठी"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>डॉ. विनय गोपाल त्रिपाठी</td>
                            <td>प्रभारी, सहायक-आचार्य</td>
                            <td>विद्यावारिधि (पी.एच.डी), एम.फिल., यू.जी.सी. नेट</td>
                            <td>8076723202</td>
                            <td>
                                <a href="mailto:hoddarshan@mvsu.ac.in">
                                    hoddarshan@mvsu.ac.in
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),

    "timetable": (
        <div>
            <p>समय सारिणी उपलब्ध नहीं है।</p>
        </div>
    ),
    "facilities": (
        <div>
            <p>सुविधाओं का विवरण उपलब्ध नहीं है।</p>
        </div>
    ),
    "events": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">दर्शन विभाग द्वारा 2023 में दिनांक 08/08/2023 से 15/08/2023 तक सप्त दिवसीय व्याकरण महाभाष्य पर कार्यशाला आयोजित की गई। इस कार्यशाला के माध्यम से विश्वविद्यालय के छात्रों ने व्याकरण शास्त्र के दार्शनिक पक्षों को समझा।</li>
                <li className="list-group-item bg-transparent border-0">दर्शन विभाग ने महर्षि वाल्मीकि शोध पीठ का सहयोग करते हुए भी द्विदिवसीय अंतरराष्ट्रीय संगोष्ठी 26 व 27 अक्टूबर 2023 का आयोजन किया। जिसमें अंतरराष्ट्रीय ख्याति प्राप्त विद्वान सम्मिलित हुए। इसी संगोष्ठी के माध्यम से नेपाल संस्कृत विश्वविद्यालय से एमओयू किया गया। जिससे विश्वविद्यालय पाण्डुलिपि एवं अन्य संसाधनों का उपयोग शोध कार्यों के लिए कर सके।</li>
            </ul>
        </div>
    ),
    "researchScholars": (
        <div>
            <p>वर्तमान में कोई शोधच्छात्र पंजीकृत नहीं हैं।</p>
        </div>
    ),
    "achievements": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">दर्शन विभागीय छात्रों द्वारा नेट व जेआरएफ की उपलब्धियां प्राप्त की गईं।</li>
            </ul>
        </div>
    ),
    "contact": (
        <div>
            <p>सम्पर्क विवरण उपलब्ध नहीं है।</p>
        </div>
    )
};

export default function FacultyPhilosophy() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about");


    const getActiveSectionName = () => {
        const activeDept = departments.find(dept => dept.id === activeContentId);
        return activeDept ? activeDept.name : "विभाग अनुभाग";
    };

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);

        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">

            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>




            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">दर्शन संकाय</h5>
                <nav className="flex-grow-1 overflow-auto pe-2">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded small cursor-pointer transition-colors ${activeContentId === dept.id ? "text-white shadow-sm" : "bg-light text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : undefined,
                                fontWeight: activeContentId === dept.id ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </nav>
            </aside>


            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">

                <h4 className="mb-3 text-center" style={{ color: '#77236b' }}>{getActiveSectionName()}</h4>

                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>


            <style jsx>{`
                .transition-colors {
                    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-effect:hover {
                    background-color: #e2e6ea !important; /* निष्क्रिय आइटमों के लिए होवर पर हल्का ग्रे */
                    color: #000 !important;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
}